import { isReactSnapCrawler } from "./prerenderData";

const MAIN_DEFER_ID = "mcverse-main";

/** Interactive browser clients (not react-snap crawlers). */
export function isInteractiveClient() {
  return !isReactSnapCrawler();
}

/** Hide stale prerender HTML and defer route swap until fresh data is ready. */
export function shouldDeferPrerender() {
  return isInteractiveClient();
}

/** Use createRoot instead of hydrateRoot for prerendered HTML. */
export function shouldSkipHydration() {
  return shouldDeferPrerender();
}

function getMainElement() {
  if (typeof document === "undefined") return null;
  return document.getElementById(MAIN_DEFER_ID);
}

export function markAppReady() {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("mcverse-app-ready");
    const main = getMainElement();
    if (main) {
      main.classList.remove("mcverse-main-deferred");
    }
  }
}

export function markAppNotReady() {
  if (typeof document !== "undefined") {
    document.documentElement.classList.remove("mcverse-app-ready");
    const main = getMainElement();
    if (main) {
      main.classList.add("mcverse-main-deferred");
    }
  }
}

/** Initial class for the main content region on interactive clients. */
export function getMainDeferClassName() {
  return shouldDeferPrerender() ? "mcverse-main-deferred" : "";
}
